const ExchangeRates = () => import("Core/configuration/currencies/views/ExchangeRates");
const ExchangeRatesForm = () => import("Core/configuration/currencies/views/ExchangeRatesForm");

export default {
    children: [
        {
            path: "exchange_rates",
            name: "exchange_rates",
            component: ExchangeRates,
            meta: {
                requiresAuth: true,
                title: "lang.exchange_rates",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_readonly",
                    "customer",
                ],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "exchange_rate/:id?",
            name: "exchange_rate",
            component: ExchangeRatesForm,
            meta: {
                requiresAuth: true,
                title: "lang.exchange_rates",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_readonly",
                    "customer",
                ],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
